export default __webpack_public_path__ + "static/media/cash-d.f8f48c51.png";